// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@rugby/XDL/Helpers";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        padding: 30px 20px 0 20px;
        background: ${getColor("common.ui3")};
        overflow-y: auto;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        ${screen("lte", "md")`
            padding-bottom: 20px;
        `}
    `,
};
